import { GOOGLE_MAPS_API_KEY } from '../config-global';

const SCRIPT_ID = 'google-maps-places-script';
const CALLBACK_NAME = 'platformSolutionsGoogleMapsLoaded';

let loaderPromise = null;

// Loads the Google Maps JS API (places library) once, on demand.
export default function loadGoogleMaps() {
  if (loaderPromise) return loaderPromise;

  if (typeof window === 'undefined') {
    return Promise.reject(new Error('Google Maps can only be loaded in the browser'));
  }

  if (window.google?.maps?.places) {
    loaderPromise = Promise.resolve(window.google);
    return loaderPromise;
  }

  if (!GOOGLE_MAPS_API_KEY) {
    return Promise.reject(new Error('Missing REACT_APP_GOOGLE_MAPS_API_KEY'));
  }

  loaderPromise = new Promise((resolve, reject) => {
    const existingScript = document.getElementById(SCRIPT_ID);
    const script = existingScript || document.createElement('script');

    window[CALLBACK_NAME] = () => {
      if (!window.google?.maps?.places?.AutocompleteSuggestion) {
        loaderPromise = null;
        script.remove();
        reject(new Error('Google Places library is unavailable'));
        return;
      }
      resolve(window.google);
    };

    if (!existingScript) {
      script.id = SCRIPT_ID;
      script.async = true;
      script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(
        GOOGLE_MAPS_API_KEY
      )}&libraries=places&loading=async&callback=${CALLBACK_NAME}`;
    }
    script.addEventListener(
      'error',
      () => {
        loaderPromise = null;
        script.remove();
        reject(new Error('Failed to load Google Maps'));
      },
      { once: true }
    );

    if (!existingScript) document.head.appendChild(script);
  });

  return loaderPromise;
}
